// Persisted in localStorage so an affirmed/verified age carries across
// sessions (unlike the per-session adult content acknowledgement).
const AGE_VERIFIED_STORAGE_KEY = 'age_verified';

export const isAgeVerified = () => {
  try {
    return localStorage.getItem(AGE_VERIFIED_STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
};

export const setAgeVerified = () => {
  try {
    localStorage.setItem(AGE_VERIFIED_STORAGE_KEY, 'true');
  } catch (error) {
    // localStorage may be unavailable (private mode / blocked); fail silently.
  }
};
